import { clsx } from "clsx"

export function cn(...inputs: any[]) {
  return clsx(inputs)
}

export function getCsrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content || ""
  )
}

export function copyToClipboard(text: string) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        App.displayFlash("success", i18n.t("js.copied"))
      })
      .catch(() => {
        // Fallback to App.executeCopy
        ;(window as any).App.executeCopy(text)
        App.displayFlash("success", i18n.t("js.copied"))
      })
  } else {
    // Fallback to App.executeCopy
    ;(window as any).App.executeCopy(text)
    App.displayFlash("success", i18n.t("js.copied"))
  }
}
